// @core/api/endpoints/context/register_aspect_manifest.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RegisterAspectManifestRequest,
  RegisterAspectManifestResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Register aspect type manifest
 * Registers or updates an aspect type manifest. Caller's product_id must match manifest.owner_product_id. Profile services call this at startup to declare their aspect types, relevance rules, and UI metadata. Third-party services authenticate via ProductGateway.
 */
export async function RegisterAspectManifest(
  aspect_type: string,
  data: RegisterAspectManifestRequest,
  options?: RequestOptions
): Promise<RegisterAspectManifestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/context/manifests/aspects/:aspect_type`;
  requestPath = requestPath.replace(':aspect_type', encodeURIComponent(aspect_type));
  const requestOptions = options;
  return client.put<RegisterAspectManifestResponse>(requestPath, data, requestOptions);
}
